<template>
  <el-dialog title="Thông báo" :visible.sync="localVisible" width="520px" :append-to-body="false">
    <div>Bài chấm của giảng viên này không gặp vấn đề gì.</div>
    <div>Bạn có xác nhận với kết quả chấm này không?</div>
    <span slot="footer" class="dialog-footer">
      <button class="btn btn-light-gray font-weight-bold mr-2" :disabled="disabled" @click="onCancel">
        <i class="fas fa-times"></i> Đóng
      </button>
      <button class="btn btn-purple font-weight-bold mr-2" :disabled="disabled" @click="$emit('confirm')">
        <i v-if="!disabled" class="fas fa-check"></i>
        <i v-else class="fas fa-spinner fa-spin"></i>
        {{ disabled ? 'Đang xác nhận...' : 'Xác nhận' }}
      </button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'SaveAllPassDialog',
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    localVisible: {
      get() { return this.visible; },
      set(v) { this.$emit('update:visible', v); }
    }
  },
  methods: {
    onCancel() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
    }
  }
}
</script>

<style scoped>
</style>


